// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  projectId: __t.string(),
  name: __t.option(__t.string()),
  description: __t.option(__t.string()),
  width: __t.option(__t.u32()),
  height: __t.option(__t.u32()),
  fps: __t.option(__t.f64()),
  backgroundColor: __t.option(__t.string()),
  posterAssetId: __t.option(__t.string()),
  archived: __t.option(__t.bool()),
};
